$(function() {


    var $wrapper = $('.upgradedHelp');
    var $menu = $('.helpcontainer .section-support-menu');

    $('.upgradedHelp a:not(.sbSelector)').unbind('click');

    $(document).on('click','.upgradedHelp .section-support-menu a:not(.settings-anchor), .support-container__ajaxhelp .link, .mobilehelp a:not(.mm-next,.mm-prev)', function (e) {
        e.preventDefault();
        $submenu = $("#my-support-menu");
        var APISubmenu = $submenu.data( "mmenu" );
        APISubmenu.close();
        $('#mm-blocker').click();
        var href = $(this).attr('href');

        $wrapper.find('.ajaxwrapper').fadeOut();
        $wrapper[0].addClass('loading');

        $wrapper.load(href, { ajax: true }, function(response, status, xhr ) {
            if ( status != "error" ) {
                history.pushState({ path: href }, '', href);
                $wrapper.find('.ajaxwrapper').fadeIn();
                $wrapper.removeClass('loading');
                ajaxHelpMenu();
                $(document).prop('title', $wrapper.find('#pageTitle').html());
                setLanguageLinks();
                $('select:not(.form-country-select):not(#frm-country):not(#frm-quantity):not(#frm-maintenance):not(.uploaded-files)').selectbox({ effect: 'slide' });
                if (window.matchMedia("(max-width: 767px)").matches) {
                    $("html, body").animate({scrollTop: $('.help-menu-mobile').offset().top - 20}, 800);
                } else {
                    $("html, body").animate({scrollTop: $('.support-products').offset().top}, 800);
                }
                return false;
            }else{
                window.location.href = href;
            }

        });
    });

    $(window).bind('popstate', function(event) {
        if($('.upgradedHelp').length){
            var state = event.originalEvent.state;
//            $wrapper.find('.ajaxwrapper').fadeOut();
//            $wrapper[0].addClass('loading');

            if (state) {
                $wrapper.load(state.path, { ajax: true }, function() {
                    $wrapper.find('.ajaxwrapper').fadeIn();
                    $wrapper.removeClass('loading');
                    $(document).prop('title', $wrapper.find('#pageTitle').html());
                });
            }
        }
    });

    function ajaxHelpMenu(){
        var $menu = $('.helpcontainer .section-support-menu');
        if($wrapper.height() < $menu.height()){
            $wrapper.css('min-height', ($menu.height()+100)+'px');
        }
    }


    function setLanguageLinks(){
        var links = $('.upgradedHelp .LangLink');

        links.each(function (e) {
            $('.languages li a.'+$(this).data('lang')).attr('href',$(this).data('href'));
        });
    }


    if($wrapper.height() < $menu.height()){
        $wrapper.css('min-height', ($menu.height()+100)+'px');
    }


    jQuery(document).ajaxComplete(function(e, xhr, settings){
      window.dataLayer = window.dataLayer || [];
      var d = document.location.pathname + document.location.search + document.location.hash;
        dataLayer.push({'utm_source': d});

        $(document).ready(function(){

            $(".ajaxwrapper .center img").each(function() {
                var img = $(this);
                // Create dummy image to get real width and height
                var caption = img.closest('p').find('.img-desc').text();

                $("<img>").attr("src", img.attr("src")).attr("source-width", img.width()).attr('data-caption', caption).load(function() {
                    var realWidth = this.width;
                    var width = parseInt($(this).attr('source-width'));
                    if (realWidth > width) {
                        var tmpImg = img.clone();
                        var $link = $("<a>").attr('href', $(this).attr('src'))
                            .attr('class', 'image-link-pointer')
                            .attr('data-caption', $(this).attr('data-caption'))
                            .attr('rel', 'lightboxNOLOOP');
                        $link.html(tmpImg);
                        $link.append("<div class=\"help-image-overlay\">\n" +
                            "  <span class=\"icon icon-search\"> </span>\n" +
                            "  </div>")
                        var $div = $("<div>").attr('class', 'help-image-container');
                        $div.html($link);
                        img.replaceWith($div);
                        $link.lightbox();
                    }
                });
            });
        });
    });


    // OPICARNA PRO STEJSKYHO!!
    var HelpPage = $('.upgradedHelp');
    if(HelpPage.length){
        var Hash = window.location.hash.substring(1);
        if (Hash.indexOf("redirect-predator-id") >= 0){
            document.cookie = 'anchor=' + Hash;
            window.location.href = window.location.href.replace(/#.*$/, '');
        }
    }


    if(HelpPage.length){
        history.replaceState({ path: window.location.href }, '');
    }





});
